import TProgress from './progress.vue'
export default TProgress



// WEBPACK FOOTER //
// ./src/components/progress/index.js